import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import './ConfirmDialog.css';

// Centered modal for a staged action that needs a review-before-commit step
// (as opposed to FilterDrawer.js's side-sheet, built for narrow settings-
// panel content) — first consumer: Ship's confirmation summary (issue #205).
// Same prop shape as FilterDrawer (title/description/children/footer) so
// the two stay easy to tell apart by which one a given screen needs, not by
// a different API to learn. Also the frame for AppDialogs.js's confirm,
// message and typed-value dialogs (issue #438).
function ConfirmDialog({ open, onOpenChange, onOpenAutoFocus, title, description, children, footer }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="confirm-dialog-overlay" />
        <Dialog.Content className="confirm-dialog-content" onOpenAutoFocus={onOpenAutoFocus}>
          <Dialog.Title className="confirm-dialog-title">{title}</Dialog.Title>
          {description && (
            <Dialog.Description className="confirm-dialog-description">
              {description}
            </Dialog.Description>
          )}
          <Dialog.Close asChild>
            <button type="button" className="confirm-dialog-close" aria-label="Close">
              <X size={16} strokeWidth={2} />
            </button>
          </Dialog.Close>
          <div className="confirm-dialog-body">{children}</div>
          {footer && <div className="confirm-dialog-footer">{footer}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default ConfirmDialog;
